import { createFileRoute } from '@tanstack/react-router'
import { SupportCoordinationWorkspace } from '@/features/support-coordination/workspace'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/',
)({
  component: SupportCoordinationWorkspace,
})
